


























































import { Component, Vue, Prop } from "vue-property-decorator"
@Component({})
export default class voucherHead extends Vue {
    @Prop({ type: Array })
    rows: any;

    @Prop({ type: String })
    theadName: any;

    @Prop({ type: Boolean })
    hasForeign: any;
}
